import { twMerge } from 'tailwind-merge';
import type {
  UndecoratedKeypoint,
  UndecoratedNote,
  UndecoratedNoteFile,
} from '@witmetrics/utils';
import type { TimelineItemType } from '@witmetrics/unison-core';
import NoteBlock from './NoteBlock';
import KeypointBlock from './KeypointBlock';
import type { TimelineVariant } from './types';
import { classes, sortItems } from './utils';

export type NotesTimelineProps = {
  showProject?: boolean;
  editable?: boolean;
  variant?: TimelineVariant;
  className?: string;
  timelineSettings?: TimelineItemType;
  keypoints?: UndecoratedKeypoint[];
  notes?: UndecoratedNote[];
  fileNotes?: UndecoratedNoteFile[];
  onOpenFile?: (fileId: number) => void;
};

export default function NotesTimeline({
  showProject = false,
  editable = true,
  variant = 'default',
  className,
  timelineSettings = 'ALL',
  keypoints = [],
  notes = [],
  fileNotes = [],
  onOpenFile,
}: NotesTimelineProps) {
  return (
    <div className={twMerge(classes.wrapper, className)}>
      {sortItems(timelineSettings, keypoints, notes, fileNotes).map((item) => {
        if (item.itemType === 'NOTE') {
          return (
            <NoteBlock
              key={`note_${item.content.id}`}
              showProject={showProject}
              editable={editable}
              noteId={item.content.id}
              variant={variant}
            />
          );
        } else if (item.itemType === 'FILE_NOTE') {
          return (
            <NoteBlock
              key={`note_${item.content.noteId}`}
              showProject={showProject}
              editable={editable}
              noteId={item.content.noteId}
              fileId={item.content.fileId}
              variant={variant}
              onOpenFile={onOpenFile}
            />
          );
        } else {
          return (
            <KeypointBlock
              key={`keypoint_${item.content.id}`}
              showProject={showProject}
              editable={editable}
              keypointId={item.content.id}
              variant={variant}
            />
          );
        }
      })}
    </div>
  );
}
